export const clinicalReviewListingColumns = (isLargerThanMedium: boolean) => [
    {
        key: 'dueDate',
        label: 'Due Date',
        sortable: true,
        width: isLargerThanMedium ? '15%' : '25%'
    },
    {
        key: 'assignedDate',
        label: 'Received Date',
        sortable: true,
        width: '15%',
        hideOnSmallScreen: true
    },
    {
        key: 'caseNumber',
        label: isLargerThanMedium ? 'Case Number' : 'Case',
        sortable: false,
        width: isLargerThanMedium ? '25%' : '35%'
    },
    {
        key: 'hasNewMessage',
        label: 'Alert',
        sortable: true,
        width: '5%',
        hideOnSmallScreen: true
    },
    {
        key: 'caseStage',
        label: 'Case Stage',
        sortable: false,
        hideOnSmallScreen: true
    },
    {
        key: 'inProgress',
        label: 'In Progress',
        sortable: false,
        width: isLargerThanMedium ? '15%' : '17%',
        align: 'center'
    }
];
